import React from "react";
import "src/components/contactsales/ContactSales.css";
import { UI } from "@wwimmo/ui";
import { ContactItemType } from "src/components/contactsales/ContactSales";

interface ContactItemProps {
    name: string;
    contacts: ContactItemRow[];
}
export interface ContactItemRow {
    type: ContactItemType;
    content: string | null;
}

export const ContactItemSales = (props: ContactItemProps) => {
    const contactItem = (index: number, type: ContactItemType, content: string | null) => {
        let icon = <></>;
        let linkType = "http://";
        if (content === null) {
            return <React.Fragment key={"item-" + index} />;
        }

        switch (type) {
            case ContactItemType.PHONE: {
                icon = <UI.Icon icon={UI.SVGIcon.PhoneOutlined} />;
                linkType = "tel:";
                break;
            }
            case ContactItemType.MAIL: {
                icon = <UI.Icon icon={UI.SVGIcon.Mail} />;
                linkType = "mailto:";
                break;
            }
            default: {
                icon = <></>;
                linkType = "http://";
                break;
            }
        }

        return (
            <div key={"item-" + index} className="ContactIcons d-flex">
                <div className="ContactIcon">{icon}</div>
                <div className="ContactDetail">
                    <a href={linkType + content}>{content}</a>
                </div>
            </div>
        );
    };

    const contactItems = props.contacts
        .filter((contact) => contact.content)
        .map((item, index) => contactItem(index, item.type, item.content));

    return (
        <div>
            <div>{contactItems.length !== 0 ? <div className="ContactDetails">{contactItems}</div> : undefined}</div>
        </div>
    );
};
